import { DropDownOptions, IBudgetAllocForm, IItemToRequest } from "src/app/shared/models/app-models";
import { calculateFinancialYear } from "./derive-budget-allocations";

export const totalAmountCalculationAO = (allocation: any[], itemList: IItemToRequest[]) => {
    return allocation.reduce((sum, allo) => {
        let item = itemList.find(x => x.AddItems.itemId == allo.PurchaseItemNo as number);
        if (!item) return sum;

        let aorAmount = 0;

        if (allo.Percentage) {
            // Calculate amount based on percentage
            aorAmount = (allo.Percentage *
                ((item.ItemPrice.UnitPrice * item.ItemPrice.Quantity * item.ItemPrice.ExchangeRate) /
                    item.ItemPrice.UnitsPerQuantity)) / 100;
            allo.aorAmount = aorAmount;
            // Add to the sum
            sum += aorAmount;
        } else {
            // Calculate amount based on quantity
            aorAmount = ((allo.Quantity ?? 0) * item.ItemPrice.UnitPrice * item.ItemPrice.ExchangeRate) /
                item.ItemPrice.UnitsPerQuantity;
            allo.aorAmount = aorAmount;
            // Add to the sum
            sum += aorAmount;
        }

        return sum;
    }, 0);
}


export const totalAORExemptedAmountCalculationAO =  (allocation: any[], itemList: IItemToRequest[]) => {
    return allocation.reduce((sum, allo) => {
        let item = itemList[(allo.PurchaseItemNo as number) - 1];
        if (!item) return sum;
        if (item.AddItems.MaterialSubGroupId?.IsExemptedAOR === true) {
            if (allo.Quantity) {
                return (
                    sum +
                    (allo.Quantity * item.ItemPrice.UnitPrice * item.ItemPrice.ExchangeRate) /
                    item.ItemPrice.UnitsPerQuantity
                );
            } else {
                console.log(
                    'check',
                    allo.Percentage,
                    item.ItemPrice.UnitPrice,
                    item.ItemPrice.Quantity,
                    item.ItemPrice.UnitsPerQuantity
                );
                return (
                    sum + ((allo.Percentage ?? 1) * ((item.ItemPrice.UnitPrice * item.ItemPrice.Quantity * item.ItemPrice.ExchangeRate) / item.ItemPrice.UnitsPerQuantity)) / 100
                );
            }
        } else {
            return sum;
        }
    }, 0)
}

export const totalAmountCalculation =  (allocation: any[], itemList: IItemToRequest[]) => {
    return allocation.reduce((sum, allo) => {
        let item = itemList.find(x => x.AddItems.itemId == allo.PurchaseItemNo as number);
        if (!item) return sum;
        if (allo.Quantity) {
            return (
                sum +
                ((allo.Quantity ?? 0) * item.ItemPrice.UnitPrice) /
                item.ItemPrice.UnitsPerQuantity
            );
        } else {
            return (
                sum +
                (allo.Percentage *
                    ((item.ItemPrice.UnitPrice * item.ItemPrice.Quantity) /
                        item.ItemPrice.UnitsPerQuantity)) /
                100
            );
        }
    }, 0);
}


export const totalAORExemptedAmountCalculation =  (allocation: any[], itemList: IItemToRequest[]) => {
    return allocation.reduce((sum, allo) => {
        let item = itemList[(allo.PurchaseItemNo as number) - 1];
        if (!item) return sum;
        if (item.AddItems.MaterialSubGroupId?.IsExemptedAOR === true) {
            if (allo.Quantity) {
                return (
                    sum +
                    (allo.Quantity * item.ItemPrice.UnitPrice) /
                    item.ItemPrice.UnitsPerQuantity
                );
            } else {
                console.log(
                    'check',
                    allo.Percentage,
                    item.ItemPrice.UnitPrice,
                    item.ItemPrice.Quantity,
                    item.ItemPrice.UnitsPerQuantity
                );
                return (
                    sum + ((allo.Percentage ?? 1) * ((item.ItemPrice.UnitPrice * item.ItemPrice.Quantity) / item.ItemPrice.UnitsPerQuantity)) / 100
                );
            }
        } else {
            return sum;
        }
    }, 0)
}


export const budgetInformation = (allBudgetAllocationForms: IBudgetAllocForm[], itemList: IItemToRequest[]) =>  {
    let ballocation: any[] = [];
    for (const budgetAllocation of allBudgetAllocationForms) {
        let item = itemList.find((i) => i.AddItems.itemId == budgetAllocation.PurchaseItemNo);
        if (item) {
            let financialYear = calculateFinancialYear(item.AddItems.PlannedDeliveryDate);
            let newbudgetAllocation = {
                ...budgetAllocation,
                FinancialYear: financialYear.FYStart,
                EndFinancialYear: financialYear.FYEnd
            };
            ballocation.push(newbudgetAllocation);
        }
    }
    return ballocation;
}
